export const getAuthApiHost = () => {
    return window.location.host.startsWith('localhost') ? 'http://localhost:8080' : 'https://mosaic.toddljones.com';
}

export const getApiHost = () => {
    return window.location.host.startsWith('localhost') ? 'http://localhost:8081' : 'https://mosaic.toddljones.com';
}
